import { DDSTypography } from 'den-design-system'
import React from 'react'
import pallete from '../../global/newPallete'

interface AbsoluteUserWithTitle {
  title: string
  value: number
}

interface SFUserCardProps {
  title: string
  total: AbsoluteUserWithTitle
  limit: AbsoluteUserWithTitle
}

const SFUserStatsCard: React.FC<SFUserCardProps> = ({
  title,
  total,
  limit
}) => {
  return (
    <div
      style={{
        borderColor: pallete.colors.stroke2,
        borderRadius: '8px'
      }}
      className='w-full max-w-[100%]  border p-[16px] h-[108px] space-y-[12px] shadow-sm bg-white flex flex-col'
    >
      <div className='flex justify-between'>
        <div className='text-start space-y-[16px]'>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark4}
            className='text-[16px]'
          >
            {total.title}
          </DDSTypography.Title>

          <DDSTypography.Title
            type='h4'
            variant='semiBold'
            color={pallete.colors.textDark3}
          >
            {total.value}
          </DDSTypography.Title>
        </div>

        <div className='text-start space-y-[16px]'>
          <DDSTypography.Title
            type='h5'
            variant='semiBold'
            color={pallete.colors.textDark4}
          >
            {limit.title}
          </DDSTypography.Title>
          <DDSTypography.Title
            type='h4'
            variant='semiBold'
            color={pallete.colors.textDark3}
          >
            {limit.value}
          </DDSTypography.Title>
        </div>
      </div>
    </div>
  )
}

export default SFUserStatsCard
